export { default } from "./FAQAccordion";
export type { FAQItem } from "./FAQAccordion";
